import FileSelector from './FileSelector'
import AuthDirectiveFn from './AuthDirective'
import ShowHideCommonToolbarController from './ShowHideCommonToolbarController'
// import ShowHideCollaborationToolbarController from './ShowHideCollaborationToolbarController'
import { doUpdateFileSelectorController } from "./ComponentController";
import {DropdownGroupController} from './DropdownGroupController'
import {createMobileDropdownTabController} from './MobileDropdownTabController'
import {createSelectionStateHandler} from './SelectTextAnnotationController/SelectionStateHandler'
import ShowOrHideInCNAreaController from './ShowOrHideInCNAreaController';
import { createOnlineSidebarDirective } from './OnlineSidebarDirective';
function initializeViewerComponents(UIExtension, emitter, {mountedCallback, onClickCallback, getEmail,hasSignIn, isAdmin}) {
    //!modules对应文档地址:https://developers.foxit.com/resources/pdf-sdk-web/api_reference/class_modular.html#aab9d9f08a682b87ad8832e168159b3fe
    if(UIExtension.modular.modules['online']){
        return
    }
    UIExtension.modular.module('online', []);
    UIExtension.modular.module('phantom', []);
    
    // ShowHideCollaborationToolbarController(UIExtension)
    ShowHideCommonToolbarController(UIExtension)
    FileSelector(UIExtension, emitter, mountedCallback, onClickCallback);

    if(UIExtension.PDFViewCtrl.DeviceInfo.isMobile){
        AuthDirectiveFn(UIExtension, emitter, {getEmail, hasSignIn, isAdmin});
        createMobileDropdownTabController(UIExtension);
    }
    ShowOrHideInCNAreaController(UIExtension);
    //createSelectTextAnnotationController(UIExtension)
    createOnlineSidebarDirective(UIExtension);
}

export {
    initializeViewerComponents,
    doUpdateFileSelectorController,
    DropdownGroupController,
    createSelectionStateHandler
}